import { useGlobalContext } from "context/GlobalContext";
import { createContext, useContext, useEffect, useState } from "react";

import { message } from "constants/responses/message";
import { dataFetchFrequency } from "constants/componentsConstants";
import { projectTaskStatusViewerApi } from "API/apis/viewer/projectTaskStatusViewer";

const initialValue = [];

const ProjectTaskDashboardContext = createContext({
  projectStatusList: [],
  setProjectStatusList: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
  currentProject: 0,
  setCurrentProject: () => {},
  currentProjectProductList: [],
  setCurrentProjectProductList: () => {},
});

export const ProjectTaskDashboardProvider = ({ children }) => {
  const [projectStatusList, setProjectStatusList] = useState(initialValue);
  const [reloadRequired, setReloadRequired] = useState(false);
  const { setIsInitializing, setError, setIsLoading } = useGlobalContext();
  const [currentProject, setCurrentProject] = useState(0);
  const [currentProjectProductList, setCurrentProjectProductList] = useState(
    []
  );

  useEffect(() => {
    setIsInitializing(true);
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const { data, status } = await projectTaskStatusViewerApi([4, 5]);
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setProjectStatusList(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
        setIsInitializing(false);
        setReloadRequired(false);
      }
    };
    fetchData();
    const intervalId = setInterval(() => {
      fetchData();
    }, dataFetchFrequency.taskDashboard);
    return () => clearInterval(intervalId);
  }, [reloadRequired]);

  useEffect(() => {
    setCurrentProjectProductList(
      projectStatusList.find((item) => item.projectId === currentProject)
        ?.products || []
    );
  }, [currentProject]);

  return (
    <ProjectTaskDashboardContext.Provider
      value={{
        projectStatusList,
        setProjectStatusList,
        reloadRequired,
        setReloadRequired,
        currentProject,
        setCurrentProject,
        currentProjectProductList,
        setCurrentProjectProductList,
      }}
    >
      <>{children}</>
    </ProjectTaskDashboardContext.Provider>
  );
};

export const useProjectTaskDashboardContext = () => {
  const context = useContext(ProjectTaskDashboardContext);
  if (!context) {
    throw new Error(
      "useProjectTaskDashboardProvider must be used within a ProjectTaskDashboardProvider"
    );
  }
  return context;
};
